import React from 'react';
/**
 * Component to display a "card" svg icon
 * @param {boolean} is_active - Boolean to determine if the icon is active. If true, an "active" style is applied to the icon
 */
const SvgCardView = (props) => {
  let is_active =
    '.CardView_svg__st1{fill:none;stroke:currentColor;stroke-width:.25;stroke-miterlimit:10;opacity:0.25}.CardView_svg__st1,.CardView_svg__st2{fill-rule:evenodd;clip-rule:evenodd;opacity:0.25}';
  if (props.is_active) {
    is_active =
      '.CardView_svg__st1{fill:none;stroke:currentColor;stroke-width:.25;stroke-miterlimit:10}.CardView_svg__st1,.CardView_svg__st2{fill-rule:evenodd;clip-rule:evenodd}';
  }

  return (
    <svg
      id="CardView_svg__Layer_1"
      x={0}
      y={0}
      viewBox="0 0 11.25 8.9"
      xmlSpace="preserve"
      width="1.5em"
      height="1.5em">
      <style>{is_active}</style>
      <path
        opacity={0.25}
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        d="M.13.13h11v8.65h-11z"
      />
      <path className="CardView_svg__st1" d="M.13.13h11v8.65h-11z" />
      <path className="CardView_svg__st1" d="M.97.9h4v4h-4z" />
      <circle className="CardView_svg__st2" cx={2.97} cy={2.4} r={1} />
      <path
        className="CardView_svg__st2"
        d="M1.27 4.9c0-.83.75-1.5 1.67-1.5s1.67.67 1.67 1.5"
      />
      <path
        className="CardView_svg__st2"
        d="M5.67.77h4.63v.78H5.67zM5.67 4.05h4.63v.78H5.67zM5.67 2.41h4.63v.78H5.67zM.87 5.69h9.43v.78H.87zM.87 7.33h9.43v.78H.87z"
      />
    </svg>
  );
};

export default SvgCardView;
